import styled, { css }from  'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LabelWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;    
    flex-direction: row;
`;

export const PlayerInfo = styled.div`
    display: flex;
    flex-direction: column;
    ${BaseStyle.Mixins.gaps.extraSmall};
`;

export const HeadshotContainer = styled.div<{ $backgroundColor: string }>`
    align-items: center;
    display: flex;
    height: fit-content;
    overflow: hidden;
    line-height: 0;
    margin-right: 16px;
    
    ${({ $backgroundColor }) =>
        $backgroundColor &&
        css`
            .headshot-container {
                background-color: ${({ $backgroundColor }) => $backgroundColor};
                border-radius: 50%;
            }
        `
    }
`;

export const PlayerName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16m']};
`;

export const PlayerDetails = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    display: flex;
    ${BaseStyle.Mixins.gaps.tiny};
`;

export const PlayerDetail = styled.div`
    color: ${({ theme }) => theme.Text.secondary };
`
